import request from '../../axios';
import {IPostCheckOrderOtpPayload} from './types';

const postCheckOrderOtp = async (payload: IPostCheckOrderOtpPayload) => {
  const data = await request.post(
    `/api/v2/payment/check-order-otp-code`,
    payload,
  );

  return data;
};

export default postCheckOrderOtp;
